// extracted by mini-css-extract-plugin
export default {"bookingIconContainer":"IconWithBackground_bookingIconContainer__lMKQP"};